import { h, Component } from 'preact';
import { Link } from 'preact-router/match';
import CartWrapper from '../shpfybtn/cartWrapper'



export default class Header extends Component {
	render() {
		const { url = '', goToMerch } = this.props
		const isShop = url.includes('/#') || url.includes('collection')

		const isShows = url.includes('shows')
		return (
			<header>
					<div class="cart" >	
					<CartWrapper url={url}  />
				</div>
				<div class="nner">
			
		
					<Link  href="/">
					<img src="../assets/asemblyline.png"/>
					</Link>
		
				<div class="imnfo" ><Link  activeClassName="active" class="" href="/info">more info</Link></div> 
				
		
				</div>	
			

			
			
			</header>
		);
	}
}
